module.exports = __webpack_public_path__ + "resources/images/polis-5fd28570df95ec23d9f86868de9be650-cache.jpg";